import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromRoot from '../../../../state/app.state';
import {
  FetchNotificationListFailure,
  FetchNotificationListRequest,
  FetchNotificationListSuccess
} from "./notifications.actions";
import {catchError, map, mergeMap, tap} from "rxjs/operators";
import {Observable, of} from "rxjs";
import {
  NotificationsService
} from 'src/app/modules/shared/services/notifications.service';

@Injectable()
export class NotificationsEffects {

  fetchReviewSurveyDetails$: Observable<Action> = createEffect(() => this.actions.pipe(ofType(FetchNotificationListRequest), map((action) => {
    return action.payload;
  }), mergeMap((payload: any) => this.notificationsService.fetchNotificationList({...payload})
    .pipe(map(res => {
      const updatedList: any[] = res.data.list.map(item => ({...item, selected: false}));
      return FetchNotificationListSuccess({payload: {...res.data, list: updatedList}})
    }), catchError(err => of(FetchNotificationListFailure())), tap((action: any) => {
      if (action.type === FetchNotificationListSuccess.type) {
        // Code to execute on API Success Action dispatch
      } else if (action.type === FetchNotificationListFailure.type) {
        // Code to execute on API Failure Action dispatch
      }
    })))))

  constructor(
    private store: Store<fromRoot.State>,
    private notificationsService: NotificationsService,
    private actions: Actions,
  ) {
  }
}
